import { makeStyles } from '@material-ui/styles';

const ManageMeetingCard: React.FC = ({ children }) => {
    const classes = useStyles();

    return <div className={classes.container}>{children}</div>;
};

const useStyles = makeStyles(
    () => ({
        container: {
            padding: '0 24px',
            margin: '24px 0',
            boxShadow: '0px 4px 14px rgba(0, 0, 0, 0.1)',
            borderRadius: 24,
            '&:last-child': {
                marginBottom: 40,
            },
        },
    }),
    { classNamePrefix: 'meetings-manage-meeting-card' }
);

export default ManageMeetingCard;
